import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';

export class ARPaymentResultDto {
    managementCompanyId: number;
    communityId: number;
    paymentId: number;
    referenceNumber: string;
    customerName: string;
    customerId: string;
    customerCode: string;
    @Type(() => Date)
    docDate: Date;
    @Type(() => Date)
    postDate: Date;
    description: string;
    subLedgerTitle: string;
    amount: number;
    unappliedAmount: number;
    transferedAmount: number;
    paymenType: string;
    @Type(() => FileInfoDisplayResultDto)
    supportingDocument: FileInfoDisplayResultDto;
    @Type(() => UpdatedResultDto)
    lastUpdate: UpdatedResultDto;
    @Type(() => Date)
    reversedDate: Date;
    @Type(() => Date)
    deletedDate: Date;
    hasCreditApplications: boolean;
    checkImagesDownloadUrl: string;
    reversedTransactionType: string;
    reversedTransactionId: number;
    reversedTransactionNumber: string;
    @Type(() => FileInfoDisplayResultDto)
    attachments: FileInfoDisplayResultDto[];
    allowReverse: boolean;
    allowTransfer: boolean;
    allowDelete: boolean;
    allowEdit: boolean;
    allowRefund: boolean;

    get appliedAmount(): number {
        return this.amount - this.unappliedAmount;
    }

    get remainingTransferableAmount(): number {
        return this.amount - this.transferedAmount;
    }
}
